/* [Diogo A.]
     - This package must use commonjs because it is imported by cube service.
 */
const { STYLE_EVALUATION } = require('./src/StyleEvaluation');

module.exports = {
  STYLE_EVALUATION,
};
